<template>
	<div class="common-phrase-side">
		<div class="side-header">
			<el-input
				v-model="searchText"
				size="small"
				clearable
				placeholder="搜索常用词"
				prefix-icon="el-icon-search">
			</el-input>
			<div class="side-actions">
				<el-button type="text" icon="el-icon-refresh" title="刷新" @click="loadTree"></el-button>
				<el-button type="text" icon="el-icon-setting" title="常用词管理" @click="goSetting"></el-button>
			</div>
		</div>
		<div class="side-body" v-loading="loading">
			<el-empty v-if="!filteredCategories.length" description="暂无常用词，请先在常用词管理中创建"></el-empty>
			<el-collapse v-else v-model="expandedNames">
				<el-collapse-item
					v-for="category in filteredCategories"
					:key="category.id"
					:name="String(category.id)">
					<template slot="title">
						<span class="category-title">{{ category.name }}</span>
						<span class="category-count">{{ category.phrases.length }}</span>
					</template>
					<div
						v-for="phrase in category.phrases"
						:key="phrase.id"
						class="phrase-item"
						:title="phrase.content"
						@click="handleSelect(phrase)">
						{{ phrase.content }}
					</div>
				</el-collapse-item>
			</el-collapse>
		</div>
	</div>
</template>

<script>
export default {
	name: "ChatQuickReplySide",
	data() {
		return {
			loading: false,
			searchText: "",
			categories: [],
			expandedNames: []
		};
	},
	computed: {
		filteredCategories() {
			const keyword = (this.searchText || "").trim().toLowerCase();
			return this.categories
				.map((category) => {
					const phrases = (category.phrases || []).filter((phrase) => {
						if (phrase.status !== 1) {
							return false;
						}
						if (!keyword) {
							return true;
						}
						return (phrase.content || "").toLowerCase().includes(keyword);
					});
					return {
						...category,
						phrases
					};
				})
				.filter((category) => category.status === 1 && category.phrases.length);
		}
	},
	watch: {
		filteredCategories: {
			immediate: true,
			handler(categories) {
				this.expandedNames = categories.map((item) => String(item.id));
			}
		}
	},
	methods: {
		loadTree() {
			this.loading = true;
			return this.$http({
				url: "/agent/common-phrase/tree",
				method: "get",
				params: {
					enabledOnly: true
				}
			}).then((list) => {
				this.categories = list || [];
			}).finally(() => {
				this.loading = false;
			});
		},
		handleSelect(phrase) {
			this.$emit("select", phrase.content || "");
		},
		goSetting() {
			this.$router.push({
				path: "/home/setting",
				query: { tab: "phrase" }
			});
		}
	},
	mounted() {
		this.loadTree();
	}
};
</script>

<style lang="scss" scoped>
.common-phrase-side {
	display: flex;
	flex-direction: column;
	height: 100%;
	background: #fff;
}

.side-header {
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 12px;
	border-bottom: var(--im-border);

	:deep(.el-input) {
		flex: 1;
	}
}

.side-actions {
	display: flex;
	align-items: center;
	flex-shrink: 0;

	.el-button {
		padding: 0 4px;
		font-size: 18px;
	}
}

.side-body {
	flex: 1;
	min-height: 0;
	overflow-y: auto;
	padding: 8px 0 12px;

	:deep(.el-collapse) {
		border-top: none;
		border-bottom: none;
	}

	:deep(.el-collapse-item__header) {
		height: 42px;
		line-height: 42px;
		padding: 0 12px;
		font-size: 13px;
		color: #303133;
		background: #fafafa;
		border-bottom: 1px solid #f0f2f5;
	}

	:deep(.el-collapse-item__wrap) {
		border-bottom: none;
	}

	:deep(.el-collapse-item__content) {
		padding: 0;
	}
}

.category-title {
	flex: 1;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.category-count {
	margin-left: 8px;
	margin-right: 8px;
	font-size: 12px;
	color: #909399;
}

.phrase-item {
	padding: 10px 14px;
	font-size: 13px;
	line-height: 20px;
	color: #606266;
	border-bottom: 1px solid #f5f5f5;
	cursor: pointer;
	transition: background-color 0.2s;

	&:hover {
		background: #f0f7ff;
		color: var(--im-color-primary);
	}

	&:last-child {
		border-bottom: none;
	}
}
</style>
